import { inject, Injectable } from '@angular/core';
import { SecondaryLinksSEO } from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderFooterMachCoreContentService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { SecondaryNavigationLinksAdapterService } from '../../adapters/secondary-navigation-links/secondary-navigation-links-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class SecondaryNavigationLinksFacadeService {
  adapter = inject(SecondaryNavigationLinksAdapterService);
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  secondaryNavigationLinksDetails$ = new BehaviorSubject<SecondaryLinksSEO>(
    {} as SecondaryLinksSEO
  );

  secondaryNavigationContent = {} as SecondaryLinksSEO;

  init(navigationId: string): void {
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .subscribe((content) => {
        this.secondaryNavigationLinksDetails$.next(
          this.adapter.getContent(content, navigationId)
        );
        this.secondaryNavigationContent = this.adapter.getContent(
          content,
          navigationId
        );
      });
  }
}
